// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"987":"1c0e96ac38f2abc3","998":"99d8d946ab37c89c"}[chunkId] + ".js";
};